import { createSlice } from '@reduxjs/toolkit';
import { TSiteType } from '../../types/common';

const initialState = {
  siteType: 'desktop' as TSiteType,
  subdomain: 'www',
};

/* istanbul ignore next */
const commonSlice = createSlice({
  initialState,
  name: 'common',
  reducers: {},
});

export const { reducer: commonReducer } = commonSlice;
